import React from 'react';
import { ILoadMoreButton } from './interfaces';
import { BORDER_COLOR } from '../../../../../../../constants';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const LoadMoreButton: React.FC<ILoadMoreButton> = ({
  onLoadMore,
  disabled = false,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        borderTop: `1px solid ${BORDER_COLOR}`,
      }}
    >
      <Button
        disabled={disabled}
        onClick={onLoadMore}
        sx={{
          width: '100%',
          textTransform: 'none',
          borderRadius: '0',
        }}
      >
        {t('feed:buttons.loadMoreComments')}
      </Button>
    </Box>
  );
};
